// extracted by mini-css-extract-plugin
module.exports = {"actionSheet":"LayoutLanguageSelector_actionSheet__1yMqr","submitButton":"LayoutLanguageSelector_submitButton__g4PWo"};